import React from "react";
import { TABLE_LIMIT } from "../../layouts/ArticleTable/ArticleTable";
import { V2Table } from "./Table";
export function DrawerTable(_a) {
    var _b;
    var headings = _a.headings, data = _a.data, rowKey = _a.rowKey, pagination = _a.pagination, dataId = _a.dataId, dataTestId = _a.dataTestId;
    var rowDrawerOffset = pagination === null || pagination === void 0 ? void 0 : pagination.drawerOffset.filter(function (drawer) { return drawer.key === rowKey; })[0];
    var rowOffset = (_b = rowDrawerOffset === null || rowDrawerOffset === void 0 ? void 0 : rowDrawerOffset.offset) !== null && _b !== void 0 ? _b : 0;
    return (React.createElement(V2Table, { dataTestId: dataTestId, dataId: dataId, headings: headings, data: data, styling: "subdued", childTable: true, pagination: pagination && {
            offset: rowOffset,
            setOffset: function (offset) {
                return pagination && (pagination === null || pagination === void 0 ? void 0 : pagination.setOffset({ offset: offset, key: rowKey }));
            },
            limit: (pagination === null || pagination === void 0 ? void 0 : pagination.limit) || TABLE_LIMIT,
            maxPagesDisplayed: 7,
            totalRecords: pagination === null || pagination === void 0 ? void 0 : pagination.totalRecords,
        } }));
}
